<template>
  <div class="PageBox">
    <div class="ScrollBox">
      <ul class="info mt10">
        <li>{{$t('InvestDetail[1]')}}：{{infoData.jiner}}</li>
        <li>{{$t('InvestDetail[2]')}}：{{infoData.profit}}</li>
        <li>{{$t('InvestDetail[3]')}}：{{infoData.start_time}}</li>
        <li>{{$t('InvestDetail[4]')}}：{{infoData.end_time}}</li>
        <li style="flex-basis: 100%">{{$t('InvestDetail[5]')}}：{{infoData.Repayment_method_info}}</li>
      </ul>
      <div class="mt10" style="overflow-x: auto">
        <table width="100%" v-if="infoData.list.length">
          <thead>
            <tr>
              <th width="50">{{$t('InvestDetail[6]')}}</th>
              <th width="80">{{$t('InvestDetail[7]')}}</th>
              <th width="80">{{$t('InvestDetail[8]')}}</th>
              <th width="80">{{$t('InvestDetail[9]')}}</th>
              <th width="80">{{$t('InvestDetail[10]')}}</th>
              <th width="80">{{$t('InvestDetail[11]')}}</th>
              <th width="50">{{$t('InvestDetail[12]')}}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="item in infoData.list" :key="item.id">
              <td>{{$t('InvestDetail[13]',{no: item.no})}}</td>
              <td>{{item.y_ben_amount}}</td>
              <td>{{item.y_interest_income}}</td>
              <td>{{item.y_all_amount}}</td>
              <td>{{item.trtime_day}}</td>
              <td>{{item.payment_amount}}</td>
              <td>{{item.state_dec}}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <van-loading v-if="isLoad" class="DataLoad" size="60px" vertical>{{$t('dialog[6]')}}</van-loading>
      <!-- <div class="block-box"></div>
      <div class="submit-btn">
        <van-button round type="danger" block style="font-size:16px;" :to="`/user/contract/${orderId}`">{{$t('InvestDetail[14]')}}</van-button>
      </div> -->
    </div>
  </div>
</template>

<script>
export default {
  components: {
  },
  props: ['orderId'],
  data() {
    return {
      isLoad: true,
      infoData: {
        jiner: 0,
        profit: 0,
        start_time: '',
        end_time: '',
        list: ''
      },
    }
  },
  computed: {

  },
  watch: {

  },
  created() {
    this.$parent.navBarTitle = this.$t('InvestDetail[0]')
    this.getInfoData()
  },
  mounted() {

  },
  activated() {

  },
  destroyed() {
    
  },
  methods: {
    getInfoData() {
      this.$Model.InvestRecordList({orderid: this.orderId},data=>{
        this.isLoad = false;
        if(data.code==1){
          this.infoData = data;
        }
      })
    },
  }
}
</script>
<style scoped>
.info{
  background-color: #fff;
  display: flex;
  flex-wrap: wrap;
  padding: 10px;
  line-height: 1;
}
.info li{
  flex-basis: 100%;
  padding: 5px;
}
table{
  text-align: center;
  background-color: var(--background-main);
  white-space: nowrap;
}
table tr {
  border-bottom: 1px #eee solid;
}
table tr th{
  padding: 6px 5px;
}
table tr td{
  padding: 10px 5px;
  font-size: 12px;
}
table tr td:first-child,table tr td:last-child{
  border-left: 0;
}
table tr td em{
  color: var(--color-important);
}
.submit-btn {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 12px;
  display: flex;
}
.block-box{
  height: 70px;
}
</style>